import React from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

interface Props {
  logProcessOnDate: string
}

export const ProcessOnDateData = ({ logProcessOnDate }: Props) => {
  const formattedDate = dayjs.utc(logProcessOnDate).format('YYYY-MM-DD')

  return <p className='mt-3 text-left'>{formattedDate}</p>
}
